export default __webpack_public_path__ + "images/sweep4.09326c0b7fbc24af992837b9b9a00040.png";